// Copyright Abridged, Inc. 2023,2024. All Rights Reserved.
// Node module: @collabland/sdk
// This file is licensed under the MIT License.
// License text available at https://opensource.org/license/mit/

import {model, property} from '@loopback/repository';

/**
 * The model class is generated from OpenAPI schema - GetQuoteResponse
 * GetQuoteResponse
 */
@model({name: 'GetQuoteResponse'})
export class GetQuoteResponse {
  constructor(data?: Partial<GetQuoteResponse>) {
    if (data != null && typeof data === 'object') {
      Object.assign(this, data);
    }
  }

  /**
   * User ID hash
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'User ID hash',
    },
  })
  userIdHash?: string;

  /**
   * Price in wei
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'Price in wei',
    },
  })
  price?: string;

  /**
   * Expiration timestamp in epoch seconds
   */
  @property({
    jsonSchema: {
      type: 'number',
      description: 'Expiration timestamp in epoch seconds',
    },
  })
  expiresAt?: number;

  /**
   * Signature of the quote
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'Signature of the quote',
    },
  })
  signature?: string;

  /**
   * ChainId of the quote
   */
  @property({
    jsonSchema: {
      type: 'number',
      description: 'ChainId of the quote',
    },
  })
  chainId?: number;

  /**
   * Waiting list contract address for given chain
   */
  @property({
    jsonSchema: {
      type: 'string',
      description: 'Waiting list contract address for given chain',
    },
  })
  contractAddress?: string;
}

export interface GetQuoteResponseRelations {
  // describe navigational properties here
}

export type GetQuoteResponseWithRelations = GetQuoteResponse &
  GetQuoteResponseRelations;
